import api from '@/api'

const state = {

}

const mutations = {

}

const actions = {
  mapListSignImageWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListSignImageWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/ecpEContract/mapListSignImageWithPage', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/ecpEContract/mapListSignImageWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  createSignImage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.createSignImage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/ecpEContract/createSignImage', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/ecpEContract/createSignImage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  delSignImage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.delSignImage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/ecpEContract/delSignImage', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/ecpEContract/delSignImage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  saveSignImage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.saveSignImage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/ecpEContract/saveSignImage', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/ecpEContract/saveSignImage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  uploadSignImage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.uploadSignImage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/ecpEContract/uploadSignImage', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/ecpEContract/uploadSignImage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  getContractPageList ({ commit, dispatch }, data) { // 获取合同图片
    return new Promise((resolve, reject) => {
      api.getContractPageList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/contract/contractPageList', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/contract/contractPageList', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  getContractDkhPageList ({ commit, dispatch }, data) { // 获取合同图片
    return new Promise((resolve, reject) => {
      api.getContractPageList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/contract/dkhPageList', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/contract/dkhPageList', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/signImage.js